<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
  <form class="form" [formGroup]="model" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Cadastro de Acesso</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <app-select-pesquisavel
          label="Selecione uma Empresa"
          [control]="listaIdEmpresaControl"
          [apiUrl]="_urlListEmpresa"
          [idField]="'idEmpresa'"
          [nameField]="'nomeEmpresa'"
          [preloadedOptions]="preloadedEmpresa"
          (selectionChange)="habilitaSelecaoUsuario()">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Selecione o(a) usuário(a)</mat-label>
          <mat-select formControlName="listaIdUsuario">
            @if (_usuarioLookupResponse) {
              @for (usuario of _usuarioLookupResponse.listaUsuario; track usuario) {
                <mat-option [value]="usuario.idUsuario">{{ usuario.nomeUsuario }}</mat-option>
              }
            }
          </mat-select>
          @if (model.get('listaIdUsuario')?.invalid) {
            <mat-error>Selecione uma empresa</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>Informe a descrição</mat-label>
          <textarea formControlName="descricaoAcesso" matInput placeholder="Descrição..."></textarea>
          @if (model.get('descricaoAcesso')?.invalid) {
            <mat-error>Informe uma descrição</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    @if (model.get('linkSuperAcesso')?.value) {
      <div id="superAcessoGerado" class="row">
        <div class="col-md-4 d-flex" style="gap: 10px">
          <button
            type="button"
            mat-flat-button
            class="btn-primary button-big"
            (click)="copiarLink()"
            [disabled]="!isLinkAcessivel">
            Copiar link
          </button>
          <button
            type="button"
            mat-flat-button
            class="btn-primary button-big"
            (click)="abrirLink()"
            [disabled]="!isLinkAcessivel">
            Acessar link
          </button>
        </div>
        <p id="tempo-limite">
          @if (isLinkAcessivel) {
            {{ temporizadorMensagem }}
          } @else {
            Link expirado!
          }
        </p>
      </div>
    }
    <div class="row">
      <div class="col-md-4 d-flex" style="gap: 10px">
        <button type="submit" mat-flat-button class="btn-primary button-big">
          @if (_isLoading === true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          } @else {
            Gerar link
          }
        </button>
        <button type="submit" mat-flat-button class="btn-secundary button-big" (click)="limpaCampos()">
          Limpar
        </button>
      </div>
    </div>
  </form>
</div>
